var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlogging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_792_3379)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#B8BCB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.1367 -12.4224L-16.3982 -36.0339L85.1101 38.4076L61.2666 60.9138L-42.1367 -12.4224Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2604 60.9119L85.1067 38.406L111.94 73.0913L90.2567 99.2068L61.2604 60.9119Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8623 67.3554C98.0459 52.5474 120.289 52.5474 131.473 67.3554C134.817 71.7839 139.404 75.1165 144.649 76.9289C162.188 82.9891 169.062 104.144 158.435 119.356C155.256 123.905 153.504 129.297 153.402 134.846C153.058 153.399 135.063 166.474 117.311 161.067C112.002 159.45 106.333 159.45 101.024 161.067C83.2722 166.474 65.2771 153.399 64.9334 134.846C64.8306 129.297 63.0785 123.905 59.9003 119.356C49.2729 104.144 56.1464 82.9891 73.6856 76.9289C78.9308 75.1165 83.5178 71.7839 86.8623 67.3554Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9469 123.027C95.0904 124.68 94.8246 126.646 95.3445 128.586C96.4503 132.713 100.692 135.162 104.819 134.056C107.266 133.401 109.123 131.643 109.999 129.461L95.9469 123.027Z",
    fill: "#2C2D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.656 123.026C140.513 124.679 140.779 126.645 140.259 128.586C139.153 132.713 134.911 135.162 130.784 134.056C128.337 133.4 126.48 131.642 125.604 129.46L139.656 123.026Z",
    fill: "#2C2D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.7733 -13.0229L-16.399 -36.0349L57.1558 70.2109L29.0053 92.0049L-41.7733 -13.0229Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0059 92.0059L57.1565 70.2118L88.3041 90.9772C90.373 92.3565 90.4598 95.4414 88.4726 96.9648L68.5369 112.248C66.5975 113.734 63.9811 113.866 61.9248 112.581L29.0059 92.0059Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_3379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlogging);
export default __webpack_public_path__ + "static/media/flogging.f53346be4f68b5dd84716706f1bedff1.svg";
export { ForwardRef as ReactComponent };